var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKyrgyzstan = function SvgKyrgyzstan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F22A46",
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.667c1.578 0 2.857-1.194 2.857-2.667 0-1.473-1.28-2.667-2.857-2.667-1.578 0-2.857 1.194-2.857 2.667 0 1.473 1.279 2.667 2.857 2.667Z",
    fill: "#FFF04D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.601 15.72 10 13.77l1.399 1.949.354-2.322 2.166 1.189-.76-2.236 2.504.195-1.724-1.707L16.286 10l-2.347-.839 1.724-1.706-2.504.194.76-2.236-2.166 1.19-.354-2.322L10 6.229 8.601 4.281l-.354 2.322-2.166-1.19.76 2.236-2.504-.194L6.06 9.16l-2.347.84 2.347.838-1.724 1.707 2.504-.195-.76 2.236 2.166-1.19.354 2.323ZM14 10c0 2.062-1.79 3.734-4 3.734S6 12.062 6 10c0-2.062 1.79-3.733 4-3.733S14 7.938 14 10Z",
    fill: "#FFF04D"
  })));
};

export default SvgKyrgyzstan;